import React from 'react';

export function FacebookLogoF() {
  return (
    <svg width="7px" height="14px" viewBox="0 0 7 14">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-3.000000, 0.000000)" fill="#FFFFFF">
          <path d="M4.5880597,14 L7.64170813,14 L7.64170813,7.62197377 L9.77247098,7.62197377 L10,5.02639543 L7.64170813,5.02639543 L7.64170813,3.54825151 C7.64170813,2.9362811 7.76359867,2.69384667 8.34693201,2.69384667 L10,2.69384667 L10,0 L7.88490879,0 C5.61252073,0 4.5880597,1.01445864 4.5880597,2.95687626 L4.5880597,5.02639543 L3,5.02639543 L3,7.65551446 L4.5880597,7.65551446 L4.5880597,14 Z"/>
        </g>
      </g>
    </svg>
  )
}